<template>
  <div class="toolsTextGenerate">
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <div v-if="this.globalVariable.tabs.length == 2">
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[0]
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[1]
          }}</el-breadcrumb-item>
        </div>
        <div v-else>
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[0]
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[1]
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[2]
          }}</el-breadcrumb-item>
        </div>
      </el-breadcrumb>
    </div>
    <div style="margin-top: 40px">
      <div class="nodeArea">
        <el-tabs
          v-model="editableTabsValue"
          type="card"
          editable
          @edit="handleTabsEdit"
        >
          <el-tab-pane
            :key="item.name"
            v-for="(item, index) in editableTabs"
            :label="item.title"
            :name="item.name"
          >
            <span style="color: red">结构路径: </span
            >&nbsp;&nbsp;&nbsp;<el-input
              placeholder="结构路径"
              v-model="structure[index]"
            ></el-input>
            <br />
            <br />

            <span style="color: red">节点内容:</span>&nbsp;&nbsp;&nbsp;
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 10 }"
              placeholder="请输入内容"
              v-model="content[index]"
            >
            </el-input>
            &nbsp;&nbsp;&nbsp;<span style="color: red">字段类型:</span
            >&nbsp;&nbsp;&nbsp;
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 10 }"
              placeholder="请输入内容"
              v-model="fieldTypes[index]"
            >
            </el-input>
          </el-tab-pane>
        </el-tabs>
      </div>
      <el-divider></el-divider>
      <!-- 结果获取 -->
      <div class="apiResult">
        <el-row>
          <el-button @click="generate('JSON')">生成JSON报文</el-button>
          <el-button type="primary" @click="generate('XML')"
            >生成XML报文</el-button
          >
          <el-button
            type="danger"
            :data-clipboard-text="copyText"
            data-clipboard-target="pre"
            class="copy"
            @click="copy()"
            >复制</el-button
          >
          <el-divider></el-divider>
        </el-row>
        <div v-show="this.format == 'JSON'">
          <pre v-html="response" class="jsonStyle"></pre>
        </div>
        <div v-show="this.format == 'XML'">
          <!-- XML格式化输出 -->
          <pre v-highlightjs="response" class="show_pre">
                  <code class="highlight_s"> </code>
              </pre>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { toolsApiGenerateText } from "@/api/api";
import vkbeautify from "vkbeautify";
// 引入复制插件
import Clipboard from "clipboard";
export default {
  data() {
    return {
      loading: true,
      editableTabsValue: "2",
      editableTabs: [
        {
          title: "结构定义",
          name: "1",
          content: "Tab 1 content",
        },
        {
          title: "结构定义",
          name: "2",
          content: "Tab 2 content",
        },
      ],
      tabIndex: 2,
      structure: ["xmldata/header[]", "xmldata/header[]/details[]"],
      content: [
        "LGORT\n\n\nRESWK\n\n\nBSART\n\nEBELN\nERDAT\nLIFNR\nBUKRS\nWERKS",
        "EBELP\nMATNR\nMENGE\nLGORT\nLOEKZ\nELIKZ\nMEINS\nVBELN\nVBELP",
      ],
      fieldTypes: [
        "String(30)\n\n\nString(50)\n\n\nString(20)\n\nString(20)\ndatetime\nString(50)\nString(200)\nString(200)\n",
        "String(200)\nString(50)\ndecimal(18,8)\nString(100)\nString(200)\nString(200)\nString(100)\nString(200)\nString(200)",
      ],
      format: "",
      response: null,
      copyText: "",
    };
  },
  created() {
    this.globalVariable.setTabs(["常用工具", "报文格式生成"]);
  },
  methods: {
    handleTabsEdit(targetName, action) {
      //添加删除结构节点
      if (action === "add") {
        //添加空结构
        this.structure.push("");
        this.content.push("");
        this.fieldTypes.push("");
        let newTabName = ++this.tabIndex + "";
        this.editableTabs.push({
          title: "结构定义",
          name: newTabName,
          content: "New Tab content" + this.tabIndex,
        });
        this.editableTabsValue = newTabName;
        console.log(this.structure);
        console.log(this.structure.length);
      }
      if (action === "remove") {
        let tabs = this.editableTabs;
        let activeName = this.editableTabsValue;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              //同时删除元素内容
              this.structure.splice(index, 1);
              this.content.splice(index, 1);
              this.fieldTypes.splice(index, 1);
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
              }
            }
          });
        }

        this.editableTabsValue = activeName;
        this.editableTabs = tabs.filter((tab) => {
          if (tab.name !== targetName) {
            return true;
          } else {
            //获得删除元素的下标
            for (let i = 0; i < tabs.length; i++) {
              let cur = tabs[i];
              if (cur.name == tab.name) {
                //同时删除元素内容
                this.structure.splice(i, 1);
                this.content.splice(i, 1);
                this.fieldTypes.splice(i, 1);
              }
            }
            return false;
          }
        });
      }
    },

    // 报文格式生成
    generate(format) {
      this.format = format;
      toolsApiGenerateText("", {
        structure: JSON.stringify(this.structure),
        content: JSON.stringify(this.content),
        fieldTypes: JSON.stringify(this.fieldTypes),
        format: format,
      }).then((res) => {
        try {
          if (this.format == "JSON") {
            this.copyText = JSON.stringify(res, null, 4);
            this.response = this.syntaxHighlight(res);
          } else {
            this.response = vkbeautify.xml(res);
            this.copyText = this.response;
          }
        } catch (error) {
          this.$alert(error.toString(), "格式化错误", {
            confirmButtonText: "确定",
            callback: (action) => {
              this.$message({
                type: "info",
                message: `action: ${action}`,
              });
            },
          });
        }
      });
    },
    // 格式化json
    syntaxHighlight(json) {
      if (typeof json != "string") {
        json = JSON.stringify(json, undefined, 2);
      }
      json = json.replace(/&/g, "&").replace(/</g, "<").replace(/>/g, ">");
      return json.replace(
        /("(\u[a-zA-Z0-9]{4}|\[^u]|[^\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
        function (match) {
          var cls = "number";
          if (/^"/.test(match)) {
            if (/:$/.test(match)) {
              cls = "key";
            } else {
              cls = "string";
            }
          } else if (/true|false/.test(match)) {
            cls = "boolean";
          } else if (/null/.test(match)) {
            cls = "null";
          }
          return '<span class="' + cls + '">' + match + "</span>";
        }
      );
    },
    copy() {
      //内容复制
      var clipboard = new Clipboard(".copy");
      //复制成功回调
      clipboard.on("success", function (e) {
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
      this.$message({
        message: "复制成功",
        type: "success",
        //显示时间毫秒
        duration: 500,
      });
    },
  },
};
</script>

<style scoped>
.nodeArea /deep/ .el-tabs__new-tab {
  float: right;
  border: 1px solid red;
  height: 18px;
  width: 18px;
  line-height: 18px;
  margin: 12px 0 9px 10px;
  border-radius: 3px;
  text-align: center;
  font-size: 12px;
  color: red;
  cursor: pointer;
  transition: all 0.15s;
}

.nodeArea /deep/ .el-input {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: 80%;
}

.nodeArea /deep/ .el-textarea {
  position: relative;
  display: inline-block;
  width: 35%;
  vertical-align: top;
  font-size: 14px;
}

.apiResult /deep/ .el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}
/* json样式 */
.jsonStyle,
.show_pre {
  outline: 1px solid #ccc;
  padding: 5px;
  margin: 5px;
}
.string {
  color: green;
}
.number {
  color: darkorange;
}
.boolean {
  color: blue;
}
.null {
  color: magenta;
}
.key {
  color: red;
}
</style>